/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type IntegrationCatalogItemCategory = typeof IntegrationCatalogItemCategory[keyof typeof IntegrationCatalogItemCategory];


export const IntegrationCatalogItemCategory = {
  ats: 'ats',
  crm: 'crm',
} as const;
